import { authedJson } from '../api/client';

export interface BoardColumn {
  columnId: string;
  workspaceId: string;
  name: string;
  order: number;
  isDone: boolean;
  createdBy: string;
  createdAt: number;
  updatedAt: number;
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const boardColumnsApi = {
  list: (workspaceId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ columns: BoardColumn[] }>(`/workspaces/${workspaceId}/board-columns`, { method: 'GET' }, getToken, doRefresh),

  create: (workspaceId: string, name: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<BoardColumn>(
      `/workspaces/${workspaceId}/board-columns`,
      { method: 'POST', body: JSON.stringify({ name }) },
      getToken,
      doRefresh,
    ),

  update: (workspaceId: string, columnId: string, name: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<BoardColumn>(
      `/workspaces/${workspaceId}/board-columns/${columnId}`,
      { method: 'PUT', body: JSON.stringify({ name }) },
      getToken,
      doRefresh,
    ),

  remove: (workspaceId: string, columnId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<void>(`/workspaces/${workspaceId}/board-columns/${columnId}`, { method: 'DELETE' }, getToken, doRefresh),

  reorder: (workspaceId: string, columnIds: string[], getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ columns: BoardColumn[] }>(
      `/workspaces/${workspaceId}/board-columns/reorder`,
      { method: 'PUT', body: JSON.stringify({ columnIds }) },
      getToken,
      doRefresh,
    ),
};
